/**
 * DetailSynopsisArrowLeftContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the detail synopsis arrow left element.
 */
const DetailSynopsisArrowLeftContainer = styled.div<React.CSSProperties>`
  cursor: pointer;
`;
export default withOpacity(DetailSynopsisArrowLeftContainer);
